/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    buttonLabel: {
        excelLikeClearSort: "Effacer le tri",
        excelLikeColumnConfigurator: "Configuration des colonnes",
        excelLikeExport: "Exporter",
        excelLikeFiltersCancelButton: "Annuler",
        excelLikeFiltersOkButton: "Ok",
        excelLikeSortAsc: "Tri ascendant",
        excelLikeSortDesc: "Tri descendant"
    },
    filterEmptyNullUndefinedValue: "(Vides)"
};